export const BUSINESS_ROOT = '/business'
export const BUSINESS_PAGE = `${BUSINESS_ROOT}/us`
export const INVOICING_ROOT = `${BUSINESS_ROOT}/invoicing`
export const QUOTES_PAGE = `${INVOICING_ROOT}/quotes`
export const JOBSEEKER_ROOT = '/jobseeker';

export const pages = {
    ADMIN_PAGE: `/admin`,
    WELCOME_PAGE: '/',
    VERIFICATION_PAGE: `/verification`,
    LOGIN_PAGE: '/auth',
    REGISTRATION_PAGE: '/registration',
    PROJECT_REQUESTS_PAGE: `/requests`,
    PROJECTS_PAGE: `${BUSINESS_ROOT}/projects`,
    CLIENTS_PAGE: `${BUSINESS_ROOT}/clients`,
    DASHBOARD_PAGE: `${BUSINESS_ROOT}/dashboard`,
    BUSINESS_PAGE: BUSINESS_PAGE,
    SUPPLIERS_PAGE: `${BUSINESS_ROOT}/suppliers`,
    DELIVERY_NOTES_PAGE: `${BUSINESS_ROOT}/delivery-notes`,
    MATERIALS_CATALOG_PAGE: `${BUSINESS_ROOT}/materials`,
    MAGAZZINO_PAGE: `${BUSINESS_ROOT}/warehouse`,
    EQUIPMENT_PAGE: `${BUSINESS_ROOT}/equipment`,
    OUTBOUND_INVOICE_PAGE: `${BUSINESS_ROOT}/invoicing/outbound`,
    INBOUND_INVOICE_PAGE: `${BUSINESS_ROOT}/invoicing/inbound`,
    SHOWCASE_PAGE: `businesses/showcase`,
    QUOTES_PAGE: QUOTES_PAGE,
    NEW_QUOTE_PAGE: `${QUOTES_PAGE}/new`,
    DOCUMENT_TEMPLATES_PAGE: `${BUSINESS_ROOT}/templates`,
    PROFORMA_PAGE: `${INVOICING_ROOT}/proforma`,
    ACCOUNTING_PAGE: `${BUSINESS_ROOT}/accounting`,
    BANKING_PAGE: `${BUSINESS_ROOT}/banking`,
    EMPLOYEES_PAGE: `${BUSINESS_ROOT}/employees`,
    TIMESHEET_PAGE: `${BUSINESS_ROOT}/timesheet`,
    OUR_SHOWCASE_PAGE: `${BUSINESS_PAGE}/showcase`,
    DATA_IMPORT_PAGE: `${BUSINESS_ROOT}/data-import`,
    JOBSEEKER_PROFILE_PAGE: `${JOBSEEKER_ROOT}/profile`,
    JOBSEEKER_LANDING_PAGE: `${JOBSEEKER_ROOT}`,
    BOARD_PAGE: `${BUSINESS_ROOT}/board`,
    MY_PROFILE_PAGE: `${BUSINESS_ROOT}/profile`,
    PRICE_LISTS_PAGE: `${BUSINESS_ROOT}/price-lists`,
}
